import { appendCurrencySymbolByLocale, getStringAsCurrency } from '@Sage/ssm-utils';

import UtilFormat from 'utils/UtilFormat';

const getLocaleDecimalFormat = () => UtilFormat._localeDecimalFormat || 'es-ES';

// Returns true for locales with decimal comma and currency symbol at left
const isLocaleSpecialFormat = () =>
    getLocaleDecimalFormat() === 'en-US' ||
    getLocaleDecimalFormat() === 'en-GB' ||
    getLocaleDecimalFormat() === 'th-TH';

export const formatNumberWithSeparator = (number) => {
    let parts;
    let formatedNumber;
    if (isLocaleSpecialFormat()) {
        parts = number.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formatedNumber = parts.join('.');
    } else {
        parts = number.toString().split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        formatedNumber = parts.join(',');
    }
    return formatedNumber;
};

export const formatLargeAmount = (number, currencySymbol, decimals = 2) =>
    appendCurrencySymbolByLocale(
        formatLargeNumber(number, decimals),
        currencySymbol,
        getLocaleDecimalFormat(),
    );

export const formatLargeNumber = (number, decimals = 2) => {
    if (isNaN(number)) return number;
    number = parseFloat(number);

    const locale = getLocaleDecimalFormat();

    if (Math.abs(number) < 1000) {
        return new Intl.NumberFormat(locale, {
            maximumFractionDigits: decimals,
        }).format(number);
    }

    return new Intl.NumberFormat(locale, {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: decimals,
    }).format(number);
};

export const formatLargeAmountCurrency = (number, useCurrency, currency, decimals = 2) => {
    let finalValue = formatLargeNumber(number, decimals);
    if (useCurrency) {
        finalValue = getStringAsCurrency(finalValue, currency, undefined, getLocaleDecimalFormat());
    }
    return finalValue;
};

export const getPercentage = (total, partial) => {
    let percentage = total !== 0 && partial !== 0 ? ((partial * 100) / total).toFixed(0) : 0;
    return percentage;
};
